interface Reviewer {
  locale: string;
  data: Array<{
    name: string;
    job: string;
    content: string;
  }>;
}

export  default  class ReviewLocale {
  public data: Array<{
    name: string;
    job: string;
    content: string;
    icon?: string;
  }> = [];

  constructor() {
    const { locale } = useI18n();
    this.data =
      dataLocales.find((item) => item.locale == locale.value)?.data ??
      dataLocales[0].data;
    this.data.forEach((item, index) => {
      item.icon = "/customer/" + item.name + ".png";
    });
  }
}

const dataLocales: Array<Reviewer> = [
  {
    locale: "en",
    data: [
      {
        name: "Alaya Walsh",
        job: "Writer",
        content:
          "I used QR Codes to share websites for wedding invitations. QR Codes are perfect and work on all platforms making sharing this information with friends and family seamless.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO & founder",
        content:
          "The customer support service is super friendly, knowledgeable and takes the time to fix your problems if they arise. I have nothing wrong to say, they are unique, and I look forward to using QR Gateway in the future for many years to come.",
      },
      {
        name: "Vincent Vu",
        job: "Developer",
        content:
          "QR Gateway is the best QR code platform by far! As a web developer, I have tested a lot, and none of them even reach the capabilities of QR Gateway.",
      },
      {
        name: "Libby Mcdonald",
        job: "Designer",
        content:
          "The website works great! It is straightforward to use and gives you a lot of great information. Any of your questions have them answered immediately. No more searching for a QR site, and you've come to the right place. I found them because of all their excellent reviews. All reviews were correct!",
      },
      {
        name: "Esmee Allen",
        job: "Sales Manager",
        content:
          "We are new to QR codes and have been using QR Gateway for over six months. Our teams love how easy it is to create, design and deploy QR codes. In addition, QR Gateway also has excellent customer support.",
      },
      {
        name: "Kacper Bennett",
        job: "Marketer",
        content:
          "QR Gateway is a great service. I've been using them for the past 4 months, and I highly recommend them.",
      },
    ],
  },
  {
    locale: "vi",
    data: [
      {
        name: "Alaya Walsh",
        job: "Nhà văn",
        content:
          "Tôi đã sử dụng mã QR để chia sẻ trang web cho lời mời đám cưới. Mã QR rất hoàn hảo và hoạt động trên tất cả các nền tảng, giúp chia sẻ thông tin này với bạn bè và gia đình trở nên dễ dàng.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO & founder",
        content:
          "Dịch vụ chăm sóc khách hàng rất thân thiện, am hiểu và sẵn sàng giúp đỡ giải quyết vấn đề của bạn. Tôi không có gì để phàn nàn, họ là độc nhất vô nhị và tôi hy vọng sử dụng QR Gateway trong tương lai trong nhiều năm tới.",
      },
      {
        name: "Vincent Vu",
        job: "Nhà phát triển",
        content:
          "QR Gateway là nền tảng mã QR tốt nhất cho đến nay! Là một nhà phát triển web, tôi đã kiểm tra nhiều nền tảng, và không có một nền tảng nào có thể đạt được những khả năng của QR Gateway.",
      },
      {
        name: "Libby Mcdonald",
        job: "Nhà thiết kế",
        content:
          "Trang web hoạt động tuyệt vời! Nó rất dễ sử dụng và cung cấp cho bạn rất nhiều thông tin tuyệt vời. Mọi câu hỏi của bạn đều được trả lời ngay lập tức. Không còn tìm kiếm một trang web mã QR nào khác, bạn đã đến đúng nơi. Tôi đã tìm thấy họ vì tất cả các đánh giá tuyệt vời của họ. Tất cả các đánh giá đều đúng!",
      },
      {
        name: "Esmee Allen",
        job: "Quản lý bán hàng",
        content:
          "Chúng tôi chưa quen với mã QR và đã sử dụng QR Gateway được hơn sáu tháng. Các nhóm của chúng tôi yêu thích việc tạo, thiết kế và triển khai mã QR dễ dàng như thế nào. Ngoài ra, QR Gateway còn có dịch vụ hỗ trợ khách hàng tuyệt vời.",
      },
      {
        name: "Kacper Bennett",
        job: "Nhà tiếp thị",
        content:
          "QR Gateway là một dịch vụ tuyệt vời. Tôi đã sử dụng họ trong 4 tháng qua và rất khuyến khích bạn sử dụng.",
      },
    ],
  },
  {
    locale: "es",
    data: [
      {
        name: "Alaya Walsh",
        job: "Escritor",
        content:
          "Usé códigos QR para compartir sitios web para invitaciones de boda. Los códigos QR son perfectos y funcionan en todas las plataformas, lo que hace que compartir esta información con amigos y familiares sea muy fácil.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO y fundador",
        content:
          "El servicio de atención al cliente es muy amigable, conocedor y se toma el tiempo para solucionar sus problemas si surgen. No tengo nada malo que decir, son únicos, y espero usar QR Gateway en el futuro durante muchos años más.",
      },
      {
        name: "Vincent Vu",
        job: "Desarrollador",
        content:
          "QR Gateway es la mejor plataforma de código QR con diferencia. Como desarrollador web, he probado muchas, y ninguna de ellas alcanza siquiera las capacidades de QR Gateway.",
      },
      {
        name: "Libby Mcdonald",
        job: "Diseñador",
        content:
          "¡El sitio web funciona genial! Es fácil de usar y te da mucha información excelente. Cualquiera de tus preguntas las responden de inmediato. No más búsqueda de un sitio de QR, y has llegado al lugar correcto. Los encontré gracias a todas sus excelentes reseñas. ¡Todas las reseñas eran correctas!",
      },
      {
        name: "Esmee Allen",
        job: "Gerente de ventas",
        content:
          "Somos nuevos en los códigos QR y hemos estado usando QR Gateway durante más de seis meses. A nuestros equipos les encanta lo fácil que es crear, diseñar e implementar códigos QR. Además, QR Gateway también tiene un excelente servicio al cliente.",
      },
      {
        name: "Kacper Bennett",
        job: "Comercializador",
        content:
          "QR Gateway es un gran servicio. Los he estado utilizando durante los últimos 4 meses, y los recomiendo altamente.",
      },
    ],
  },
  {
    locale: "fr",
    data: [
      {
        name: "Alaya Walsh",
        job: "Écrivaine",
        content:
          "J'ai utilisé des codes QR pour partager des sites web pour les invitations de mariage. Les codes QR sont parfaits et fonctionnent sur toutes les plateformes, ce qui rend le partage de cette information avec les amis et la famille facile.",
      },
      {
        name: "Lawrence Holland",
        job: "PDG et fondateur",
        content:
          "Le service client est super sympathique, compétent et prend le temps de résoudre vos problèmes s'ils se produisent. Je n'ai rien à redire, ils sont uniques et j'ai hâte d'utiliser QR Gateway à l'avenir pendant de nombreuses années.",
      },
      {
        name: "Vincent Vu",
        job: "Développeur",
        content:
          "QR Gateway est de loin la meilleure plateforme de code QR ! En tant que développeur web, j'en ai testé beaucoup, et aucun d'entre eux ne peut même atteindre les capacités de QR Gateway.",
      },
      {
        name: "Libby Mcdonald",
        job: "Designer",
        content:
          "Le site web fonctionne très bien ! Il est facile à utiliser et vous donne beaucoup d'informations utiles. Toutes vos questions ont une réponse immédiate. Plus besoin de chercher un site de codes QR, vous êtes au bon endroit. Je les ai trouvés grâce à toutes leurs excellentes critiques. Toutes les critiques étaient correctes !",
      },
      {
        name: "Esmee Allen",
        job: "Directrice des ventes",
        content:
          "Nous sommes nouveaux dans les codes QR et utilisons QR Gateway depuis plus de six mois. Nos équipes adorent la facilité avec laquelle il est possible de créer, concevoir et déployer des codes QR. De plus, QR Gateway offre un excellent support client.",
      },
      {
        name: "Kacper Bennett",
        job: "Marketer",
        content:
          "QR Gateway est un excellent service. Je l'utilise depuis 4 mois maintenant et je le recommande vivement.",
      },
    ],
  },
  {
    locale: "pt",
    data: [
      {
        name: "Alaya Walsh",
        job: "Escritora",
        content:
          "Eu usei códigos QR para compartilhar sites de convites de casamento. Os códigos QR são perfeitos e funcionam em todas as plataformas, tornando o compartilhamento dessas informações com amigos e familiares sem problemas.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO e fundador",
        content:
          "O serviço de suporte ao cliente é super amigável, experiente e dedica tempo para resolver seus problemas, caso ocorram. Eu não tenho nada a reclamar, eles são únicos e espero usar o QR Gateway no futuro por muitos anos.",
      },
      {
        name: "Vincent Vu",
        job: "Desenvolvedor",
        content:
          "QR Gateway é a melhor plataforma de código QR de longe! Como desenvolvedor web, eu testei muitos e nenhum deles chega nem perto das capacidades do QR Gateway.",
      },
      {
        name: "Libby Mcdonald",
        job: "Designer",
        content:
          "O site funciona muito bem! É fácil de usar e fornece muitas informações úteis. Todas as suas perguntas são respondidas imediatamente. Não há mais procurar por um site de QR, você está no lugar certo. Eu os encontrei por causa de todas as suas excelentes avaliações. Todas as avaliações estavam corretas!",
      },
      {
        name: "Esmee Allen",
        job: "Gerente de vendas",
        content:
          "Somos novos em códigos QR e estamos usando o QR Gateway há mais de seis meses. Nossas equipes adoram como é fácil criar, projetar e implantar códigos QR. Além disso, o QR Gateway também tem excelente suporte ao cliente.",
      },
      {
        name: "Kacper Bennett",
        job: "Comerciante",
        content:
          "QR Gateway é um ótimo serviço. Eu tenho usado há 4 meses e recomendo muito.",
      },
    ],
  },
  {
    locale: "ja",
    data: [
      {
        name: "Alaya Walsh",
        job: "ライター",
        content:
          "私はウェディング招待状のウェブサイトを共有するためにQRコードを使用しました。QRコードは完璧で、すべてのプラットフォームで動作するため、友人や家族との情報共有がシームレスに行えます。",
      },
      {
        name: "Lawrence Holland",
        job: "CEO＆創業者",
        content:
          "カスタマーサポートサービスはとてもフレンドリーで知識があり、問題が発生した場合は時間をかけて解決してくれます。何も悪いことは言えません、彼らはユニークで、QR Gatewayを今後も多くの年にわたって使用することを楽しみにしています。",
      },
      {
        name: "Vincent Vu",
        job: "開発者",
        content:
          "QR Gatewayは間違いなく最高のQRコードプラットフォームです！ Web開発者として、たくさん試した中でも、QR Gatewayは能力が最も高いです。",
      },
      {
        name: "Libby Mcdonald",
        job: "デザイナー",
        content:
          "ウェブサイトは素晴らしいです！使い方が簡単で、多くの素晴らしい情報を提供してくれます。何か質問があればすぐに答えが返ってきます。QRサイトを探す必要がなく、ここに来れば正しい場所です。彼らをすべての素晴らしいレビューのおかげで見つけました。すべてのレビューは正しかったです！",
      },
      {
        name: "Esmee Allen",
        job: "セールスマネージャー",
        content:
          "私たちはQRコードに新しく、QR Gatewayを6か月以上使用しています。チームはQRコードを簡単に作成、設計、展開できることが大好きです。さらに、QR Gatewayには優れたカスタマーサポートもあります。",
      },
      {
        name: "Kacper Bennett",
        job: "マーケター",
        content:
          "QR Gatewayは素晴らしいサービスです。過去4か月間使用しており、強くお勧めします。",
      },
    ],
  },
  {
    locale: "nl",
    data: [
      {
        name: "Alaya Walsh",
        job: "Schrijver",
        content:
          "Ik heb QR-codes gebruikt om websites voor bruiloftsuitnodigingen te delen. QR-codes zijn perfect en werken op alle platforms, waardoor het delen van deze informatie met vrienden en familie naadloos verloopt.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO & oprichter",
        content:
          "De klantenservice is super vriendelijk, deskundig en neemt de tijd om uw problemen op te lossen als ze zich voordoen. Ik heb niets verkeerds te zeggen, ze zijn uniek en ik kijk ernaar uit om QR Gateway in de toekomst nog vele jaren te gebruiken.",
      },
      {
        name: "Vincent Vu",
        job: "Ontwikkelaar",
        content:
          "QR Gateway is veruit het beste QR-codeplatform! Als webontwikkelaar heb ik veel getest en geen van hen komt zelfs in de buurt van de mogelijkheden van QR Gateway.",
      },
      {
        name: "Libby Mcdonald",
        job: "Ontwerper",
        content:
          "De website werkt geweldig! Het is eenvoudig te gebruiken en biedt veel geweldige informatie. Uw vragen worden direct beantwoord. Geen gedoe meer met het zoeken naar een QR-site, u bent op de juiste plek. Ik heb ze gevonden vanwege al hun uitstekende beoordelingen. Alle beoordelingen waren correct!",
      },
      {
        name: "Esmee Allen",
        job: "Verkoopmanager",
        content:
          "We zijn nieuw in QR-codes en gebruiken QR Gateway al meer dan zes maanden. Onze teams zijn dol op hoe gemakkelijk het is om QR-codes te maken, ontwerpen en implementeren. Bovendien heeft QR Gateway ook uitstekende klantenondersteuning.",
      },
      {
        name: "Kacper Bennett",
        job: "Marketeer",
        content:
          "QR Gateway is een geweldige service. Ik gebruik ze al 4 maanden en beveel ze ten zeerste aan.",
      },
    ],
  },
  {
    locale: "it",
    data: [
      {
        name: "Alaya Walsh",
        job: "Scrittore",
        content:
          "Ho usato i codici QR per condividere i siti web per gli inviti di nozze. I codici QR sono perfetti e funzionano su tutte le piattaforme, rendendo la condivisione di queste informazioni con amici e familiari senza soluzione di continuità.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO e fondatore",
        content:
          "Il servizio di assistenza clienti è super cordiale, competente e si prende il tempo di risolvere i problemi se si presentano. Non ho nulla da dire di sbagliato, sono unici e non vedo l'ora di utilizzare QR Gateway anche in futuro per molti anni a venire.",
      },
      {
        name: "Vincent Vu",
        job: "Sviluppatore",
        content:
          "QR Gateway è di gran lunga la migliore piattaforma di codici QR! Come sviluppatore web, ne ho testati molti e nessuno di essi raggiunge nemmeno le capacità di QR Gateway.",
      },
      {
        name: "Libby Mcdonald",
        job: "Designer",
        content:
          "Il sito web funziona alla grande! È facile da usare e fornisce molte informazioni interessanti. Qualsiasi domanda ha una risposta immediata. Non c'è più bisogno di cercare un sito QR, sei nel posto giusto. Li ho trovati grazie a tutte le loro ottime recensioni. Tutte le recensioni erano corrette!",
      },
      {
        name: "Esmee Allen",
        job: "Responsabile delle vendite",
        content:
          "Siamo nuovi ai codici QR e utilizziamo QR Gateway da oltre sei mesi. I nostri team adorano quanto sia facile creare, progettare e implementare i codici QR. Inoltre, QR Gateway ha anche un'ottima assistenza clienti.",
      },
      {
        name: "Kacper Bennett",
        job: "Marketer",
        content:
          "QR Gateway è un ottimo servizio. Li uso da 4 mesi e li consiglio vivamente.",
      },
    ],
  },
  {
    locale: "de",
    data: [
      {
        name: "Alaya Walsh",
        job: "Schriftstellerin",
        content:
          "Ich habe QR-Codes verwendet, um Websites für Hochzeitseinladungen zu teilen. QR-Codes sind perfekt und funktionieren auf allen Plattformen, so dass das Teilen dieser Informationen mit Freunden und Familie nahtlos verläuft.",
      },
      {
        name: "Lawrence Holland",
        job: "CEO & Gründer",
        content:
          "Der Kundensupport-Service ist super freundlich, kompetent und nimmt sich Zeit, um Ihre Probleme zu lösen, falls sie auftreten. Ich habe nichts zu bemängeln, sie sind einzigartig und ich freue mich darauf, QR Gateway in Zukunft für viele Jahre zu nutzen.",
      },
      {
        name: "Vincent Vu",
        job: "Entwickler",
        content:
          "QR Gateway ist mit Abstand die beste QR-Code-Plattform! Als Webentwickler habe ich viele getestet, und keiner von ihnen erreicht auch nur annähernd die Fähigkeiten von QR Gateway.",
      },
      {
        name: "Libby Mcdonald",
        job: "Designerin",
        content:
          "Die Website funktioniert super! Sie ist einfach zu bedienen und bietet viele nützliche Informationen. Alle Ihre Fragen werden sofort beantwortet. Kein Suchen mehr nach einer QR-Site, Sie sind hier genau richtig. Ich habe sie aufgrund all ihrer ausgezeichneten Bewertungen gefunden. Alle Bewertungen waren korrekt!",
      },
      {
        name: "Esmee Allen",
        job: "Vertriebsleiterin",
        content:
          "Wir sind neu in QR-Codes und nutzen QR Gateway seit über sechs Monaten. Unsere Teams lieben es, wie einfach es ist, QR-Codes zu erstellen, zu gestalten und zu implementieren. Darüber hinaus bietet QR Gateway auch einen ausgezeichneten Kundensupport.",
      },
      {
        name: "Kacper Bennett",
        job: "Vermarkter",
        content:
          "QR Gateway ist ein großartiger Service. Ich benutze ihn seit 4 Monaten und empfehle ihn sehr.",
      },
    ],
  },
  {
    locale: "zh",
    data: [
      {
        name: "Alaya Walsh",
        job: "作家",
        content:
          "我用QR码分享了婚礼邀请的网站链接。QR码完美无缺，并且适用于所有平台，让与朋友和家人分享信息变得无缝。",
      },
      {
        name: "Lawrence Holland",
        job: "首席执行官和创始人",
        content:
          "客户支持服务超级友好，知识渊博，如果出现问题，他们会花时间解决。我没有任何不满意的地方，他们是独一无二的，我期待在未来的许多年里继续使用QR Gateway。",
      },
      {
        name: "Vincent Vu",
        job: "开发人员",
        content:
          "QR Gateway是目前为止最好的QR码平台！作为Web开发人员，我已经测试了很多，但没有一个能够达到QR Gateway的功能。",
      },
      {
        name: "Libby Mcdonald",
        job: "设计师",
        content:
          "这个网站运行得非常好！使用起来非常简单，并且提供了许多有用的信息。您的任何问题都会立即得到回答。不再需要搜索QR网站，您来对地方了。我是通过他们所有的好评找到他们的。所有的评价都是正确的！",
      },
      {
        name: "Esmee Allen",
        job: "销售经理",
        content:
          "我们刚开始使用QR码，已经使用QR Gateway超过六个月了。我们的团队喜欢它的易用性，设计和部署QR码都很容易。此外，QR Gateway还提供出色的客户支持。",
      },
      {
        name: "Kacper Bennett",
        job: "市场营销人员",
        content:
          "QR Gateway是一个非常好的服务。我已经使用它们4个月了，强烈推荐。",
      },
    ],
  },
];
